import { Checkbox, Skeleton, Toolbar, Tooltip } from '@mui/material';
import { action, observable, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import ImportacaoProcessosStore from '../../store/ImportacaoProcessosStore';
import PaginacaoImportacaoStore from '../../store/PaginacaoImportacaoStore';
import AccordionProcessoImportacao from '../AccordionProcessoImportacao';

interface IPropsPaginacaoModalImportacao {
    onSelect?: () => void;
}

interface IStateComponent {
}

class PaginacaoModalImportacao extends React.Component<IPropsPaginacaoModalImportacao> {
    selecionarTodos = false;

    selectionarTudo = () => {
        this.selecionarTodos = !this.selecionarTodos;
        ImportacaoProcessosStore.selectionarTudo(this.selecionarTodos);
        this.props.onSelect && this.props.onSelect();
    };

    constructor(props: IPropsPaginacaoModalImportacao) {
        super(props);

        makeObservable(this, {
            selecionarTodos: observable,
            selectionarTudo: action
        });
    }

    renderSkeleton = () => {
        return (
            <div className="skeletonListaImportacao" aria-label="Carregando processos">
                <Toolbar variant="dense" className="skeletonSelecionarTodos">
                    <Skeleton variant="rounded" width={18} height={18} />
                    <Skeleton variant="text" width={120} height={28} />
                </Toolbar>
                <div className="skeletonProcessosImportacao">
                    {Array.from({ length: 5 }).map((_, index) => (
                        <div className="skeletonProcessoImportacao" key={index}>
                            <Skeleton variant="rounded" width={18} height={18} />
                            <Skeleton variant="text" width="35%" height={28} />
                            <Skeleton variant="rounded" width={22} height={22} />
                            <Skeleton variant="text" width={32} height={26} />
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    render() {
        if (ImportacaoProcessosStore.isCarregandoProcessos) {
            return this.renderSkeleton();
        }

        return (
            <>
                <Toolbar
                    variant="dense"
                    style={{ paddingLeft: '4px' }}>
                    <Tooltip
                        title="Selecionar todos"
                        onClick={this.selectionarTudo}>
                        <Checkbox value={this.selecionarTodos ?? ''} />
                    </Tooltip>
                    <span>Selecionar Todos</span>
                </Toolbar>
                <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, overflowY: 'auto', height: '100%' }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {ImportacaoProcessosStore.processosQuePodemSerImportadosFiltrado.slice(PaginacaoImportacaoStore.primeiroIndice, PaginacaoImportacaoStore.ultimoIndice)
                            .map((processoExt) => {
                                return (
                                    <div key={processoExt.identificadorProcesso} className="acordionImportacao" style={{ padding: '4px' }}>
                                        <AccordionProcessoImportacao processo={processoExt} onSelect={this.props.onSelect} />
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
            </>
        );
    }
}

export default observer(PaginacaoModalImportacao);
